/* Zoom da imagem de produto ao passar o rato, sem clique.
   Paprika, 2 de Setembro de 2026. Terceira tentativa, e desta vez por
   outro caminho.

   Porque as duas anteriores falharam: ampliavam a propria <img> com
   transform: scale(). O problema e que a imagem vive dentro de
   <responsive-image class="f-image">, que e um elemento personalizado e
   que no CSS do tema so tem "width" e "vertical-align". Nao tem
   display: block. Um elemento inline ignora overflow: hidden, por isso a
   regra que devia recortar a imagem ampliada nao fazia nada, e o
   resultado era imprevisivel.

   Esta versao nao toca na <img>. Cria uma camada por cima do bloco da
   fotografia com a versao grande da imagem como fundo (o endereco ja esta
   no atributo data-src, que o tema escreve para o zoom em janela) e move
   o fundo com o rato. Nao depende de nenhuma regra de CSS do tema, por
   isso nao pode ser anulada por elas.

   So actua em ecras com rato, a partir de 990px. Em toque nao ha
   "passar o rato" nenhum, e la o toque para ampliar continua a funcionar. */
(function () {
  var ESCALA = 2;
  var MEDIA = 'media-gallery[data-hover-zoom="true"] .f-product__media--image';
  var CLASSE = 'paprika-zoom-lente';

  function podeFazerHover() {
    return (
      window.matchMedia('(hover: hover) and (pointer: fine)').matches &&
      window.matchMedia('(min-width: 990px)').matches
    );
  }

  function mediaDoEvento(evento) {
    var alvo = evento.target;
    if (!alvo || !alvo.closest) return null;
    return alvo.closest(MEDIA);
  }

  function lenteDe(media) {
    var lente = media.querySelector('.' + CLASSE);
    if (lente) return lente;

    /* data-src e a imagem grande que o tema ja prepara para o zoom em
       janela. Se nao existir, nao ha nada de qualidade para ampliar. */
    var url = media.dataset.src;
    if (!url) return null;

    if (window.getComputedStyle(media).position === 'static') {
      media.style.position = 'relative';
    }
    media.style.overflow = 'hidden';

    lente = document.createElement('div');
    lente.className = CLASSE;
    lente.setAttribute('aria-hidden', 'true');
    lente.style.cssText =
      'position:absolute;top:0;right:0;bottom:0;left:0;' +
      'background-repeat:no-repeat;background-position:center;' +
      'pointer-events:none;opacity:0;transition:opacity .18s ease;z-index:2;';
    lente.style.backgroundImage = 'url("' + url + '")';
    lente.style.backgroundSize = ESCALA * 100 + '%';
    media.appendChild(lente);
    return lente;
  }

  function ampliar(media, evento) {
    var lente = lenteDe(media);
    if (!lente) return;
    var limites = media.getBoundingClientRect();
    if (!limites.width || !limites.height) return;
    var x = ((evento.clientX - limites.left) / limites.width) * 100;
    var y = ((evento.clientY - limites.top) / limites.height) * 100;
    lente.style.backgroundPosition = x + '% ' + y + '%';
    lente.style.opacity = '1';
  }

  function largar(media) {
    var lente = media.querySelector('.' + CLASSE);
    if (lente) lente.style.opacity = '0';
  }

  document.addEventListener(
    'pointermove',
    function (evento) {
      if (evento.pointerType === 'touch' || !podeFazerHover()) return;
      var media = mediaDoEvento(evento);
      if (media) ampliar(media, evento);
    },
    { passive: true }
  );

  document.addEventListener(
    'pointerout',
    function (evento) {
      var media = mediaDoEvento(evento);
      if (!media) return;
      if (evento.relatedTarget && media.contains(evento.relatedTarget)) return;
      largar(media);
    },
    { passive: true }
  );

  /* O cliente quer o zoom ao passar o rato, nao ao clicar. Em computador
     travamos o clique que abre a imagem em janela, para nao haver dois
     comportamentos a competir pelo mesmo gesto. Em telemovel e tablet o
     toque para ampliar fica intacto: e a unica forma de ampliar la. */
  document.addEventListener(
    'click',
    function (evento) {
      if (!podeFazerHover()) return;
      var media = mediaDoEvento(evento);
      if (!media) return;
      evento.preventDefault();
      evento.stopPropagation();
    },
    true
  );

  /* Se a janela ficar estreita ou o utilizador passar para toque, esconde
     qualquer lente que tenha ficado acesa. */
  window.addEventListener('resize', function () {
    if (podeFazerHover()) return;
    document.querySelectorAll(MEDIA).forEach(largar);
  });
})();
